exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".governingDocsList {\n  margin-left: 25px;\n  margin-right: 25px;\n}\n\n.justified {\n  text-align: justify;\n}\n\n.linkGroup {\n  margin-top: 10px;\n}\n\n.smallSubtitles {\n  margin-bottom: 10px;\n}\n\n.deleteLink {\n  color: #FF0052;\n}\n\n.deleteLink:hover {\n  border-radius: 3px;\n  background-color: #FF0052;\n  color: #fff;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.inlineBlock {\n  display: inline-block;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/docs/docs.component.css
// module id = ../../../../../src/app/docs/docs.component.css
// module chunks = main